/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
// Example <textarea name="message" class="form-control text-editor" data-type="tiny" id="ticketMessageTextarea" cols="30" rows="2" required></textarea>
export function textEditor(element) {
  var typeEditor = element.dataset.type ? element.dataset.type : 'default';
  var toolbar = 'formatselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor removeformat | numlist bullist | outdent indent | image media link | alignleft aligncenter alignright alignjustify | fullscreen | code';
  var editorHeight = 500;
  var editorQuickBarSelectionToolbar = 'bold italic underline | quicklink | h2 h3 h4 | forecolor';
  if (typeEditor === 'miny') {
    toolbar = 'bold italic underline strikethrough | forecolor | numlist bullist |  link | code';
    editorHeight = 300;
    editorQuickBarSelectionToolbar = false;
  }
  if (typeEditor === 'tiny') {
    toolbar = 'bold italic underline | numlist bullist | link';
    editorHeight = 200;
    editorQuickBarSelectionToolbar = false;
  }
  if (tinymce.get(element.id)) {
    // console.log('test', tinymce.get(element.id))
    tinymce.get(element.id).destroy();
    // tinymce.EditorManager.editors = [];
  }
  // console.log('test3', tinymce.get(element.id))

  tinymce.init({
    target: element,
    branding: false,
    menubar: false,
    // skin: 'GravitonTinyLight',
    // skin: 'tinymce-5',
    plugins: 'image  lists code  link media quickbars fullscreen',
    //hr paste
    toolbar: toolbar,
    elementpath: false,
    // toolbar_sticky: true,
    image_class_list: [{
      title: 'None',
      value: ''
    }, {
      title: 'Float',
      menu: [{
        title: 'start',
        value: 'float-start img-fluid me-2 mb-2 mt-2'
      }, {
        title: 'sm start',
        value: 'float-sm-start img-fluid me-2 mb-2 mt-2'
      }, {
        title: 'md start',
        value: 'float-md-start img-fluid me-2 mb-2 mt-2'
      }, {
        title: 'lg start',
        value: 'float-lg-start img-fluid me-2 mb-2 mt-2'
      }, {
        title: 'xl start',
        value: 'float-xl-start img-fluid me-2 mb-2 mt-2'
      }, {
        title: 'end',
        value: 'float-end img-fluid ms-2 ms-2 ms-2'
      }, {
        title: 'sm end',
        value: 'float-sm-end img-fluid ms-2 ms-2 ms-2'
      }, {
        title: 'md end',
        value: 'float-md-end img-fluid ms-2 ms-2 ms-2'
      }, {
        title: 'lg end',
        value: 'float-lg-end img-fluid ms-2 ms-2 ms-2'
      }, {
        title: 'xl end',
        value: 'float-xl-end img-fluid ms-2 ms-2 ms-2'
      }]
    }],
    // content_css: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css',
    content_style: '.img-fluid{max-width:100%;height:auto}.float-start{float:left!important}.float-end{float:right!important}@media (min-width:576px){.float-sm-start{float:left!important}.float-sm-end{float:right!important}}@media (min-width:768px){.float-md-start{float:left!important}.float-md-end{float:right!important}}@media (min-width:992px){.float-lg-start{float:left!important}.float-lg-end{float:right!important}}@media (min-width:1200px){.float-xl-start{float:left!important}.float-xl-end{float:right!important}}',
    image_advtab: true,
    image_uploadtab: true,
    images_upload_handler: function images_upload_handler(blobInfo, progress) {
      var formData = new FormData();
      formData.append('file', blobInfo.blob());
      formData.append('type', 'general-image');
      var headersObj = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data'
      };
      // todo: check !!!
      return httpRequest({
        url: adminConfig.routes.imageUpload,
        data: formData,
        headers: headersObj
      }).then(function (response) {
        if (response && response.data) {
          // if (response.data.error) {
          // 	failure(response.data.error);
          // }
          if (response.data.success) {
            // console.warn(window.location.origin + response.data.image.path);
            return window.location.origin + response.data.image.path;
            // success(window.location.origin + response.data.image.path);
          }
        }
      })["catch"](function (error) {
        // failure(error);
        console.error(error);
      });
    },
    importcss_append: true,
    height: editorHeight,
    fontsize_formats: '12px 14px 16px 18px 24px 30px 36px 48px',
    quickbars_insert_toolbar: '',
    quickbars_selection_toolbar: editorQuickBarSelectionToolbar,
    noneditable_noneditable_class: 'mceNonEditable',
    toolbar_mode: 'wrap',
    contextmenu: 'link image',
    setup: function setup(editor) {
      editor.ui.registry.addButton('gallery', {
        tooltip: 'Gallery',
        icon: 'gallery',
        onAction: function onAction(_) {
          openModal({
            modalId: 'g-tiny-editor',
            modalSize: 'xl',
            templateType: 'getGallery',
            modalBackdrop: 'static'
          });
        }
      });
      editor.on('change', function () {
        tinymce.triggerSave();
      });
    }
  });
}
export function textEditorInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  if (typeof tinymce != "undefined") {
    var textEditorElements = container.querySelectorAll(".text-editor");
    for (var i = 0; i < textEditorElements.length; i++) {
      textEditor(textEditorElements[i]);
    }
  }
}